
import Axios from "axios";

import { apiUrl, serializeObjToGetStr } from "../../constants";

const syncBaseUrl = `${apiUrl}/sync`;
const config = {
    headers: { "Content-Type": "application/json-patch+json" }
};

export const syncApi = {
  getIp: () => {
    return Axios.get(`${syncBaseUrl}/ip`);
  },

  // get: ()  => {
  //   return Axios.get(`${syncBaseUrl}/ip`);
  // },
  // save: inventory => {
  //   return Axios.post(syncBaseUrl, inventory, config);
  // },
};
